import type {
  TestRecordIssue,
  UniversalIssueWithScreenshot
} from '@deque/axe-devtools-issues-utils';

export const getIssuesWithUniversalMatches = (
  issues: TestRecordIssue[],
  universalIssues: UniversalIssueWithScreenshot[]
) => {
  const universalIssueIds = universalIssues.reduce((acc, { issueId }) => {
    if (issueId !== null && issueId !== undefined) {
      acc[issueId] = issueId;
    }

    return acc;
  }, {} as { [key: string]: string });

  return issues.filter(issue => !!universalIssueIds[issue.id]);
};
